import { TYPE_LABELS } from '../data/schedule';

function formatTime(time) {
  const [hours, minutes] = time.split(':').map(Number);
  const period = hours >= 12 ? 'م' : 'ص';
  const h = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
  return `${h}:${minutes.toString().padStart(2, '0')} ${period}`;
}

function ScheduleItem({ item }) {
  return (
    <article className={`schedule-item type-${item.type} ${item.fixed ? 'is-fixed' : ''} ${item.highlight ? 'is-highlight' : ''}`}>
      <div className="schedule-time">
        <time>{formatTime(item.time)}</time>
        {item.endTime && <span className="time-end">– {formatTime(item.endTime)}</span>}
      </div>
      <div className="schedule-body">
        <div className="schedule-meta">
          <span className={`type-badge badge-${item.type}`}>{TYPE_LABELS[item.type]}</span>
          {item.fixed && <span className="fixed-badge">ثابت</span>}
          {item.optional && <span className="optional-badge">اختياري</span>}
          {item.highlight && <span className="highlight-badge">موصى به</span>}
        </div>
        <h3 className="schedule-title">{item.title}</h3>
        {item.location && <p className="schedule-location">{item.location}</p>}
        {item.notes && <p className="schedule-notes">{item.notes}</p>}
      </div>
    </article>
  );
}

function ScheduleTimeline({ items }) {
  if (!items?.length) {
    return <p className="empty-state">لا توجد عناصر في الجدول لهذا اليوم.</p>;
  }

  return (
    <div className="schedule-timeline">
      {items.map((item, index) => (
        <ScheduleItem key={`${item.time}-${index}`} item={item} />
      ))}
    </div>
  );
}

export default ScheduleTimeline;
